import { isEmptyObj } from '@/siteBuilder/utils/isEmptyObj'
import { IConstructData, IConstructDataObject } from '../FormBuilder'

const makePrefillObject = (data: Record<string, unknown> = {}, constructDataObject: IConstructDataObject = {}) => {
  if (isEmptyObj(data) || !constructDataObject.keyPathArray) return {}
  return constructDataObject.keyPathArray.reduce((acc, obj: IConstructData) => {
    const nestedVal = obj.path.reduce((a, pathKey) => {
      if (!a) return
      return a[pathKey]
    }, data)

    acc[obj.key] = nestedVal
    return acc
  }, {})
}

export default makePrefillObject
